import {IconButton} from '@mui/material';
import {SnackbarProvider, SnackbarProviderProps} from 'notistack';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

export function CustomSnackbarProvider(props: SnackbarProviderProps) {
  const notistackRef = React.createRef<SnackbarProvider>();

  const onClickDismiss = (key: string) => () => {
    if (notistackRef.current) {
      notistackRef.current.closeSnackbar(key);
    }
  };

  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      ref={notistackRef}
      action={(key: string) => (
        <IconButton color="inherit" onClick={onClickDismiss(key)}>
          <CloseIcon />
        </IconButton>
      )}
      {...props}
    />
  );
}
